import type React from "react";

import styles from "./ServiceIconTextPair.module.scss";

interface ServiceIconTextPairProps {
  icon: React.ReactNode;
  title: string;
}

export const ServiceIconTextPair: React.FC<ServiceIconTextPairProps> = ({ icon, title }) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper} aria-hidden="true">
        {icon}
      </div>
      <span className={styles.title}>{title}</span>
    </div>
  );
};
